import { render, staticRenderFns } from "./OpenBalanceItems.vue?vue&type=template&id=45d28248&scoped=true&"
import script from "./OpenBalanceItems.vue?vue&type=script&lang=js&"
export * from "./OpenBalanceItems.vue?vue&type=script&lang=js&"
import style0 from "./OpenBalanceItems.vue?vue&type=style&index=0&id=45d28248&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d28248",
  null
  
)

export default component.exports